module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1C0QBv7/tc-custom/9781466854666.jpg?1738254592706",
      "alt": "This image is the cover for the book The Slaughter Man, The Max Wolfe Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Slaughter Man, The Max Wolfe Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Max Wolfe is back-the two-fisted homicide detective with a small daughter and dog waiting for him at home, and a crazed serial killer waiting for him somewhere out in the pitiless London streets."), _c('br'), _c('br'), _vm._v("On New Year's Day, a wealthy family is found slaughtered inside their exclusive gated community, their youngest child stolen away. The murder weapon-a gun used to stun cattle before they are butchered-leads Max to a dusty corner of Scotland Yard's Black Museum devoted to a mass murderer who, 30 years ago, was known as The Slaughter Man. But The Slaughter Man has done his time and is now old and dying. Is he really back in the killing game? And was the slaughter of a happy family a mindless killing spree, or a grotesque homage by a copycat killer, or a contract hit designed to frame a dying man? Max desperately needs to find the missing child and stop the killer before he destroys another innocent family-or finds his way to Detective Wolfe's own front door."), _c('br'), _c('br'), _c('i', [_vm._v("The Slaughter Man")]), _vm._v(" is another taut thriller from acclaimed international bestseller Tony Parsons.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tony Parsons\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Minotaur\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0